import api from './api';
import { ApiResponse } from '../types';

export interface ExamAttendanceSheetStudent {
  studentId:   string;
  name:        string;
  rollNumber:  string | number;
  sectionName: string | null;
}

/** One paper's roster — previewed on screen and printed as the exam-hall signature sheet. */
export interface ExamAttendanceSheetData {
  exam:    { _id: string; name: string; startDate: string; endDate: string };
  session: { _id: string; name: string };
  class:   { _id: string; name: string };
  section: { _id: string; name: string } | null;
  subject: { _id: string; name: string; maxMarks: number };
  students: ExamAttendanceSheetStudent[];
}

interface ExamAttendanceSheetQuery {
  examId:             string;
  subjectId:          string;
  sectionInstanceId?: string | null;
}

const getPreview = async (q: ExamAttendanceSheetQuery): Promise<ExamAttendanceSheetData> => {
  const res = await api.get<ApiResponse<ExamAttendanceSheetData>>('/examination/exam-attendance-sheet', {
    params: { examId: q.examId, subjectId: q.subjectId, sectionInstanceId: q.sectionInstanceId || undefined },
  });
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data!;
};

const examAttendanceSheetService = {
  getPreview,
};

export default examAttendanceSheetService;
